define([
	"dojo/_base/declare",
	"dijit/registry",
	"csi/action",
	"csi/action/ActionView",
	"csi/action/Controller",
	"csi/comm",
	"csi/def",
	"csi/reflection",
	"csi/xml"
], function(declare, registry, action, ActionView, Controller, comm, def, reflection, xml) {

	return declare(Controller, {
		constructor: function(/*Object*/params) {
			// the node on which we are acting is the parent
			var idComposite = this.m_action.compositeId;
			this.m_urlParent = this.m_urlNode;
			this.m_urlNode = idComposite ? this.getParent()[idComposite] : null;
		},

		getActionView: function(/*def.ViewRef?*/vr) {
			// summary: look for create form if creating node and ViewRef not specified
			if (this.m_bToggle) return null;

			var av = this.inherited(arguments);
			if (av) return av;

			if (this.m_action.idForm) {
				var rcr = reflection.getRelation(this.getParent(), this.m_action.compositeId);
				if (rcr) {
					var rc = rcr.getDestinationClass();
					if (rc && !rc.abstractOrDisabled) {
						var defView = def.getClassViewDef(rc, this.m_action.idForm);
						if (defView) {
							return new ActionView(this, defView);
						}
					}
				}
			}

			return null;
		},

		getFormData: function() {
			// summary: require one selection
			var data = this.inherited(arguments);

			if (!this.m_bToggle) {
				data.m_bSelectOne = true;
				data.m_bRequireOne = true;
			}

			return data;
		},

		toWriter: function() {
			// summary: manage/unmanage node
			var a = this.m_action;
			var w = this.m_writer;
			var urlFrom;
			var call;

			if (this.m_bToggle) {
				// unmanage node
				w.deleteNode(this.m_urlNode);
				this.m_urlNode = null;
			} else {
				// manage node
				this.m_urlNode = comm.createUrl();
				if (!this.m_urlNode) throw new Error("URLCREATE");

				// extract selection from pop-up view if present before continuing
				if (this.m_formData) {
					var nodeFrom = this.m_formData.getSelectedNode();
					if (nodeFrom) {
						urlFrom = nodeFrom.$URL;
					}
				}

				var call = this.inherited(arguments);
				if (call) {
					if (urlFrom) {
						call.addParameter(xml.PROP_URL_FROM, xml.ATTR_REF, urlFrom);
					}
				} else if (urlFrom) {
					w.copyNode(this.m_urlNode, urlFrom);
				} else {
					w.createNode(this.m_urlNode, a.compositeClass);
				}

				// write out fields from form (if any) - omit parent fields until after node is attached to parent
				this.toWriterFields(this.m_urlNode, null, function(f) {
					return !f.m_path || f.m_path.indexOf(reflection.PATH_PARENT) != 0;
				});

				// add to parent
				if (!call) {
					w.changeNode(this.m_urlParent).changeAttribute(a.compositeId, xml.ATTR_REF, this.m_urlNode);
				}

				// write out parent fields from form (if any)
				this.toWriterFields(this.m_urlNode, null, function(f) {
					return f.m_path && f.m_path.indexOf(reflection.PATH_PARENT) == 0;
				});
			}
		},

		postProcess: function(/*Boolean*/bStatus, /*Boolean*/bRepeat) {
			// summary: if action failed or was cancelled, restore toggle state
			if (!bStatus) {
				var e = registry.byNode(this.m_element);
				if (e) {
					e.set("checked", this.m_bToggle);
				}
			}

			this.inherited(arguments);
		},

		postProcessSuccess: function() {
			// summary: refresh view when done if not already handled
			return this.inherited(arguments) || this.widget.redrawNode(this.m_element);
		}
	});
});